import * as React from "react";
import { useQuery } from "convex/react";
import { api } from "$convex/convexApi";
import { useAuthIdentity } from "@/contexts/UserProfileContext";
import { useAppLocale } from "@/lib/i18n";
import { sortByName } from "@/lib/sort";

export function useSamples(limit = 200) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.samples.getAllSampleRequests,
    authUserId ? { authUserId, limit } : "skip",
  );
}

export function useSamplesByStatus(status: string, limit = 200) {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.samples.getAllSampleRequests,
    authUserId ? { authUserId, status, limit } : "skip",
  );
}

export function useSampleAdminStats() {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.samples.getSampleRequestAdminStats,
    authUserId ? { authUserId } : "skip",
  );
}

export function useCarriers() {
  const { authUserId } = useAuthIdentity();
  const { locale } = useAppLocale();
  const carriers = useQuery(
    api.samples.getCarriers,
    authUserId ? { authUserId } : "skip",
  ) as Array<{ _id: string; name?: string | null }> | undefined;

  return React.useMemo(
    () => sortByName(carriers, locale),
    [carriers, locale],
  );
}
